import store from '../store'
import {formatRelativeTime} from "luxon/src/impl/english";

class ApiRequest {
    constructor() {
        this.instance = window.axios.create({
            baseURL: '/api/v1/proxy',
            timeout: 25000,
        });
        this.locationId = window.application.locationId ? window.application.locationId : null;
    }

    call(url = '', method = 'GET', data = []) {
        let request = {method, data};
        return this.instance({
            url,
            method: 'POST',
            data: request
        });
    }

    altLocation() {
        this.locationId = store.getters['filter/rentLocation'] ?? this.locationId;
        return this;
    }

    getToken(credentials) {

        return this.call('/bike-rent/get-token', 'POST', credentials);
    }

    getBraintreeToken() {
        return this.altLocation().call('/bike-rent/get-brain-token', 'GET', {
            debug: process.env.NODE_ENV === 'development',
            location_id: this.locationId
        });
    }

    getLocation() {
        return this.call('/bike-rent/location/' + this.locationId);
    }

    getLocations() {
        return this.call('/bike-rent/locations');
    }

    getAccessories() {
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/accessories');
    }

    getEventAccessories(event_id) {
        return this.altLocation().call('/bike-rent/event/' + event_id + '/accessories');
    }

    getMerchandises() {
        // interceptor to put some custom fields into response object
        this.instance.interceptors.response.use((response) => {
            response.data.merchandises = response.data.merchandises.map(merchandise => {
                merchandise.prices = [];
                for (const [key, value] of Object.entries(JSON.parse(merchandise.price))) {
                    merchandise.prices.push({
                        size: key,
                        ...value
                    });
                }
                return merchandise;
            });
            return response;
        });
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/accessories');
    }

    getTours(withNotTag) {
        // interceptor to put some custom fields into response object
        this.instance.interceptors.response.use((response) => {
            response.data.tours = response.data.tours.map(tour => {
                tour.bike_types = tour.bike_types.map(bike => {
                    return {
                        ...bike,
                        bike_type: {
                            ...bike.bike_type,
                            insurance: response.data.insurance
                                ? response.data.insurance[bike.type_id] ? response.data.insurance[bike.type_id].insurance : null
                                : null
                        }
                    }
                });

                tour = {
                    ...tour,
                    final_price: tour.price - (tour.price * (tour.discount / 100))   // custom field
                }
                return tour;
            });
            return response;
        });
        return this.call(`/bike-rent/location/${this.locationId}/tours`);

    }

    getTourById(tourId) {
        // interceptor to put some custom fields into response object
        this.instance.interceptors.response.use((response) => {
            response.data.tour.bike_types = response.data.tour.bike_types.map(bike => {
                return {
                    ...bike,
                    bike_type: {
                        ...bike.bike_type,
                        insurance: response.data.insurance
                            ? response.data.insurance[bike.type_id] ? response.data.insurance[bike.type_id].insurance : null
                            : null
                    }
                }
            });

            response.data.tour = {
                ...response.data.tour,
                final_price: response.data.tour.price - (response.data.tour.price * (response.data.tour.discount / 100))
            }
            return response;
        });

        return this.call('/bike-rent/location/' + this.locationId + '/tour/' + tourId);
    }

    convertTourBySlugResponse(response) {
        // interceptor to put some custom fields into response object
        response.data.tour.bike_types = response.data.tour.bike_types.map(bike => {
            return {
                ...bike,
                bike_type: {
                    ...bike.bike_type,
                    insurance: response.data.insurance
                        ? response.data.insurance[bike.type_id] ? response.data.insurance[bike.type_id].insurance : null
                        : null
                }
            }
        });

        response.data.tour = {
            ...response.data.tour,
            final_price: response.data.tour.price - (response.data.tour.price * (response.data.tour.discount / 100))
        }
        return response;
    }

    convertRentalBySlugResponse(response) {
        // interceptor to put some custom fields into response object
        let rental = response.data.type;
        rental.time_options_price = rental.time_options_price.map(price => {
            price = {
                ...price,
                final_price: price.price// - (price.price * (rental.discount / 100))        // custom field
            }
            return price;
        });
        rental.image = {
            image: rental.image !== undefined ? rental.image : '',
            fullImage: rental.fullImage !== undefined ? rental.fullImage : ''
        }

        rental.type_name = rental.name;
        rental.type_id = rental.id;

        rental.amount = 0;
        rental.price = 0;
        rental.final_price = 0;
        return rental;
    }

    convertRentalBikesResponse(response) {
        return response.map(i => {
            i.amount = 0;
            i.price = 0;
            i.final_price = 0;
            return i;
        })
    }

    getTourBySlug(tourSlug) {
        // interceptor to put some custom fields into response object
        this.instance.interceptors.response.use((response) => {
            this.convertTourBySlugResponse(response)
        });

        return this.call('/bike-rent/location/' + this.locationId + '/tour-slug/' + tourSlug);
    }


    getEvents() {
        // interceptor to put some custom fields into response object
        this.instance.interceptors.response.use((response) => {
            response.data.tours = response.data.events.map(event => {
                event.bike_events = event.bike_events.map(bike => {
                    return {
                        ...bike,
                        bike_type: {
                            ...bike.bike_type,
                            insurance: response.data.insurance
                                ? response.data.insurance[bike.type_id] ? response.data.insurance[bike.type_id].insurance : null
                                : null
                        }
                    }
                });

                event = {
                    ...event,
                    price: 0,
                    final_price: 0   // custom field
                }
                return event;
            });
            return response;
        });
        return this.call('/bike-rent/location/' + this.locationId + '/events');
    }

    getEventBySlug(eventSlug) {
        // interceptor to put some custom fields into response object
        this.instance.interceptors.response.use((response) => {
            response.data.bikes = response.data.event.bike_events.map(bike => {

                bike.event_time_option_price = bike.event_time_option_price.map(price => {
                    price = {
                        ...price,
                        final_price: price.price - (price.price * (bike.discount / 100))        // custom field
                    }
                    return price;
                })

                bike.final_price = bike.price - (bike.price * (bike.discount / 100));
                bike.type_name = bike.bike_type.name;
                bike.image = {
                    image: bike.bike_type.image !== undefined ? bike.bike_type.image : '',
                    fullImage: bike.bike_type.fullImage !== undefined ? bike.bike_type.fullImage : ''
                }
                return bike;
            });
            return response;

        });

        return this.call('/bike-rent/location/' + this.locationId + '/event-slug/' + eventSlug);
    }

    getBikes(altLocation = true) {
        // interceptor to put some custom fields into response object
        this.instance.interceptors.response.use((response) => {
            response.data.bikes = response.data.bikes.map(bike => {
                bike.time_options_price = bike.time_options_price.map(price => {
                    price = {
                        ...price,
                        final_price: price.price - (price.price * (bike.discount / 100))        // custom field
                    }
                    return price;
                })
                bike.amount = 0;
                return bike;
            });
            return response;
        });
        if (altLocation) this.altLocation();

        return this.call('/bike-rent/location/' + this.locationId + '/bikes');

    }
    getBikesNotLocation(altLocation = true) {
        // interceptor to put some custom fields into response object
        this.instance.interceptors.response.use((response) => {
            response.data.bikes = response.data.bikes.map(bike => {
                bike.time_options_price = bike.time_options_price.map(price => {
                    price = {
                        ...price,
                        final_price: price.price - (price.price * (bike.discount / 100))        // custom field
                    }
                    return price;
                })

                return bike;
            });
            return response;
        });
        return this.call('/bike-rent/location/0/bikes');
    }

    getTypes(altLocation = true) {
        // interceptor to put some custom fields into response object
        this.instance.interceptors.response.use((response) => {

            response.data.types = response.data.types.map(type => {
                type.image = {
                    image: type.image !== undefined ? type.image : '',
                    fullImage: type.fullImage !== undefined ? type.fullImage : ''
                }

                return type;
            })
            return response;
        });
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/types');
    }

    getTimeOptions() {
        return this.call('/bike-rent/time-options');
    }

    getAdditionalOptions() {
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/additional-options');
    }

    getEventAdditionalOptions(event_id) {
        return this.altLocation().call('/bike-rent/event/' + event_id + '/additional-options');
    }

    getProducts() {
        return this.call('/bike-rent/location/' + this.locationId + '/products');
    }

    getProductById(productId) {
        return this.call('/bike-rent/location/' + this.locationId + '/product/' + productId);
    }

    getProductBySlug(productSlug) {
        return this.call('/bike-rent/location/' + this.locationId + '/product-slug/' + productSlug);
    }

    getSpecialOffers() {
        return this.instance({
            baseURL: '/api/v1',
            url: '/special-offer',
            method: 'GET'
        });
    }

    getAttractions() {
        return this.instance({
            baseURL: '/api/v1',
            url: '/attraction',
            method: 'GET'
        });
    }

    getBlogPosts(page = 1) {
        return this.instance({
            baseURL: '/api/v1',
            url: '/blog-post',
            method: 'GET',
            params: {
                page
            }
        });
    }

    getInstagramFeed() {
        return this.instance({
            baseURL: '/api/v1',
            url: '/instagram/feed',
            method: 'GET'
        });
    }

    getDiscount(promoCode) {
        return this.call('/discount', 'GET', {code: promoCode});
    }

    checkout(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/checkout', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/checkout', 'POST', data);
    }

    checkoutAmount(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/checkout-amount', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/checkout-amount', 'POST', data);
    }

    createDigitalWalletOrder(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/create-digital-wallet-order', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/create-digital-wallet-order', 'POST', data);
    }

    applePayValidateSession(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/apple-pay-validate-session', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/apple-pay-validate-session', 'POST', data);
    }

    createPaypalOrder(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/create-paypal-order', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/create-paypal-order', 'POST', data);
    }

    capturePaypalOrder(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/capture-paypal-order', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/capture-paypal-order', 'POST', data);
    }

    cancelPaypalOrder(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/cancel-paypal-order', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/cancel-paypal-order', 'POST', data);
    }

    createStripePaymentIntent(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/stripe/create-payment-item', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/stripe/create-payment-item', 'POST', data);
    }

    updateStripePaymentIntent(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/stripe/update-payment-item', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/stripe/update-payment-item', 'POST', data);
    }

    cancelStripePaymentIntent(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/stripe/cancel-payment-item', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/stripe/cancel-payment-item', 'POST', data);
    }

    captureStripeOrder(data) {
        if (data.type !== 'rental' && data.type !== 'event') {
            return this.call('/bike-rent/location/' + this.locationId + '/capture-stripe-order', 'POST', data);
        }
        return this.altLocation().call('/bike-rent/location/' + this.locationId + '/capture-stripe-order', 'POST', data);
    }


    _tourInterceptor() {

        return this;
    }

    setUserLocation(data) {
        // return this.call('/bike-rent/get-token', 'POST', data);
        return this.call('/bike-rent/store-user-location', 'POST', data);
    }

    sendContacts(data) {
        return this.call('/bike-rent/send-contacts', 'POST', data);
    }

}

export {ApiRequest as default}
